function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class RestLinkError extends Error {
    constructor(message){
        super(message);
        _define_property(this, "__internalError", void 0);
        this.__internalError = true;
    }
}
export { RestLinkError as default };

//# sourceMappingURL=RestLinkError.js.map